// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"290cdd6f","246":"a646c153","410":"af97b288","495":"a772bf8d","542":"4f9e7a24","968":"ebc803fd","992":"0725f946"}[chunkId] + ".chunk.js";
};